import React, { useState, useEffect } from "react"
import { Trans } from "@lingui/react"
import OtherIncomeAndExpenses from "./OtherIncomeAndExpenses"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { selectCreatedVslaInfo } from "../../store/reducers/getVslas"
import styles from "./OtherIncome.module.css"

const OtherIncome = (props) => {
  const [vsla_id, setVslaId] = useState("")
  const { vslaSummary, currentMember } = useSelector((state) => ({
    vslaSummary: selectCreatedVslaInfo(state),
    currentMember: state.loadedMember,
  }))

  useEffect(() => {
    const { vsla } = vslaSummary[0]
    setVslaId(vsla?.id)
  }, [vslaSummary])

  return (
    <div>
      <div>
        <h4 className={styles.header}>{currentMember?.full_name}</h4>
      </div>
      <h4 className={styles.header}>
        <Trans id="title_copy.otherIncome">GROUP INCOME</Trans>
      </h4>
      <OtherIncomeAndExpenses
        amount={props.amount}
        vsla_id={vsla_id}
        history={props.history}
        sourceFundType="issuer"
        destination={props.destination}
        otherType="Group income"
        inputName="destination"
        offlineMeeting={props.offlineMeeting}
      />
    </div>
  )
}

OtherIncome.propTypes = {
  amount: PropTypes.string,
  history: PropTypes.object,
  destination: PropTypes.string,
  offlineMeeting: PropTypes.object,
}

export default OtherIncome
